import { DETECT_ROUTE_ANIMATION } from "../constants/actionTypes";

export default (state = false, action) => {
  switch (action.type) {
    case DETECT_ROUTE_ANIMATION:
      return !state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/pageAnimationReducer.js